import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { Post } from '../../../shared/dtos/post';

@Component({
  components: {
  },
})
export default class PostComponent extends Vue {
  @Prop() public post!: Post;

  public openPost() {
    this.$router.push(this.post.ambitId + '/post/' + this.post.id);
  }
}